/**
 * Données des gares et stations de transport autour de Disneyland Paris
 * Coordonnées GPS et URLs des iframes pour les horaires
 */

export const TRANSPORT_LOCATIONS = {
  'RER_Chessy': {
    id: 'RER_Chessy',
    name: 'Gare RER A - Chessy Marne-la-Vallée',
    shortName: 'RER A Chessy',
    latitude: 48.8708,
    longitude: 2.7829,
    type: 'RER',
    line: 'A',
    iframeUrl: 'https://monrer.fr/?s=MVC',
    icon: '/images/buttons/IDF_RER_A_logo.svg',
    color: '#e3051c' // Rouge RER A
  },
  'SNCF_Chessy': {
    id: 'SNCF_Chessy',
    name: 'Gare SNCF - Marne-la-Vallée Chessy',
    shortName: 'SNCF Chessy',
    latitude: 48.870862868300016,
    longitude: 2.7825249719393694,
    type: 'SNCF',
    line: 'TGV/TER',
    iframeUrl: 'https://carto.tchoo.net/48.6,3,7,0,0/8711184',
    icon: '/images/buttons/sncf-trains.png',
    color: '#0073c0' // Bleu SNCF
  }
};

/**
 * Liste des stations de transport pour itération
 */
export const TRANSPORT_STATIONS = Object.values(TRANSPORT_LOCATIONS);

export default TRANSPORT_LOCATIONS;
